export default class EaseNumber {

    constructor (mValue, mEasing = 0.1) {
        this.easing = mEasing
        this._value = mValue
        this._targetValue = mValue
        this._min = -Infinity
        this._max = Infinity
        this.start()
    }

    _update = () => {
        const MIN_DIFF = 0.0001
        this._checkLimit()
        this._value += (this._targetValue - this._value) * this.easing
        if (Math.abs(this._targetValue - this._value) < MIN_DIFF) {
            this._value = this._targetValue
        }

        this._efIndex = requestAnimationFrame(this._update)
    };

    setTo(mValue) {
        this._targetValue = this._value = mValue
    }

    add(mAdd) {
        this._targetValue += mAdd
    }

    setEasing(easing) {
        this.easing = easing
    }

    limit(mMin, mMax) {
        if (mMin > mMax) {
            this.limit(mMax, mMin)
            return
        }

        this._min = mMin
        this._max = mMax

        this._checkLimit()
    }

    _checkLimit() {
        if (this._min !== undefined && this._targetValue < this._min) {
            this._targetValue = this._min
        }

        if (this._max !== undefined && this._targetValue > this._max) {
            this._targetValue = this._max
        }
    }

    start() {
        this._efIndex = requestAnimationFrame(this._update)
        this.active = true
    }

    stop() {
        this._efIndex && cancelAnimationFrame(this._efIndex)
        this.active = false
    }

    destroy() {
        this.stop()
    }

    //	GETTERS / SETTERS

    set value(mValue) {
        if (mValue === undefined) {
            return
        }
        this._targetValue = mValue
    }

    get value() {
        return this._value
    }

    get targetValue() {
        return this._targetValue
    }
}
